import React, { useEffect, useRef, useState } from 'react';
import axios from '../axiosConfig';
import { handleError, toastError, toastErrorUniqueInfinite, toastInfo, toastInfoUniqueInfinite, toastSuccess } from '../funciones.js';
import Filtros from './Filtros.js';
import Modal from './Modal';
import ModalPerfil from './ModalPerfil';
import Paginacion from './Paginacion';
import logoEliminar from '../assets/logoEliminar.png';
import logoEditar from '../assets/logoEditar.png';
import { LoaderTabla } from './LoaderTabla.js';

function Tabla(props) {

    const [cantPaginas, setCantPaginas] = useState(1);
    const [cantPaginasCopia, setCantPaginasCopia] = useState(1);
    const [pagActual, setPagActual] = useState(1);
    //const [paginaActual, setPaginaActual] = useState([]);
    const [elementos, setElementos] = useState([]);
    // Id del evento al que se está inscribiendo, para que un doble click no mande dos pedidos
    const [inscribiendo, setInscribiendo] = useState(null);
    const [elementosCopia, setElementosCopia] = useState([]);
    const [elementosTotal, setElementosTotal] = useState([]);
    const [cantidadElementos, setCantidadElementos] = useState([]);
    const abortRef = useRef(null);
    const [primeraCarga, setPrimeraCarga] = useState(true);
    const [idsElemModif, setIdsElemModif] = useState([]);
    const [perfil, setPerfil] = useState({ rubros: [], productosOfrecidos: [], nombre: '' });
    const [horaSalida, setHoraSalida] = useState(-1);
    const [horaEntrada, setHoraEntrada] = useState(-1);
    const [permitirElegirHorario, setPermitirElegirHorario] = useState(false);
    const [skipSearchEffect, setSkipSearchEffect] = useState(false);
    const [loadingCount, setLoadingCount] = useState(0);
    const mostrarLoader = loadingCount > 0;


    const [filtros, setFiltros] = useState({
        productosOfrecidos: [''],
        productosDemandados: [''],
        rubros: [-1]
    });

    //const [search, setSearch] = useState("");

    //var cantPaginas;
    useEffect(() => {
        /* const elem = document.getElementById("root");
 
         const footer = document.getElementById("footer");
         const navBar = document.getElementById("navBar");
         const encabezado = document.getElementById("encabezado");
         const tabla = document.getElementById("tabla");
         //tabla.style.height = "calc(100vh - " + (footer.scrollHeight + navBar.scrollHeight + encabezado.scrollHeight) + "px)";
 
         //-VEERRtabla.style.height = (elem.offsetHeight - (footer.scrollHeight + navBar.scrollHeight + encabezado.scrollHeight)) + "px";
         //const altAct = document.getElementById("idAct1").offsetHeight;
         const altAct = 72;//VERR
         /*var cantTotalElementos = 2 ;
         if(cantTotalElementos < cantElementos){
             cantElementos = cantTotalElementos;
         }*/
        /*if(window.screen.height > 800)
            cantElementos =  tabla.scrollHeight / altAct - 2;
        else* /
        const cantElementos = tabla.offsetHeight / altAct - 2;
        setCantidadElementos(cantElementos);*/
        var url, params;
        if (props.seccionId !== 2) {
            url = `evento/disponiblesParaInscribirseDeUnaEmpresa`;
            params = {
                empresaId: localStorage.getItem(process.env.REACT_APP_ID_EMPRESA),
                page: pagActual - 1,
            }
            /*axios
                .get(process.env.REACT_APP_URL + url, params)
                .then(function (response) {
                    const data = response.data.content;
                    setCantPaginas(response.data.totalPages);
                    setElementos(data)
                })
                .catch(function (error) {
                    toastError(handleError(error))
                });*/
            getElements(params, url)
        } else {
            seleccionarEmpresas(false, null, null, null, true)
        }
    }, [pagActual])

    const getElements = (params = {}, url, method = "GET") => {
        if (abortRef.current) {
            abortRef.current.abort();
        }

        const controller = new AbortController();
        abortRef.current = controller;
        setLoadingCount(prev => prev + 1);
        axios({
            url: process.env.REACT_APP_URL + url,
            method,
            ...(method === "GET"
                ? { params }
                : { data: params }),
            signal: controller.signal
        }).then(response => {
            setElementos(response.data.content);
            setCantPaginas(Math.max(response.data.totalPages, 1));
        }).catch(err => {
            if (err.name === "CanceledError") return;
            toastError(handleError(err))
        }).finally(() => setLoadingCount(prev => Math.max(prev - 1, 0)))
    };


    /*useEffect(() => {
        if (props.seccionId === 2 || props.esAdmin) {
            document.getElementById("buscarText").addEventListener("keyup", function () {
                setSearch(document.getElementById("buscarText").value)
                seleccionarEmpresas(false)
            });
        }
    }, [])*/

    useEffect(() => {
        seleccionarEmpresas(false)
    }, [props.idInscripcion])

    useEffect(() => {
        if (skipSearchEffect)
            setSkipSearchEffect(false)
        else
            seleccionarEmpresas(false)
    }, [props.search])

    function seleccionarEmpresas(esFiltrar, badgesOferta, badgesDemanda, badgesRubro, esPaginacion) {

        if (props.search && esFiltrar) {
            setSkipSearchEffect(true);
            props.setSearch("");
        }

        if (!esPaginacion)
            setPagActual(1);

        if (props.idInscripcion === undefined || props.idInscripcion === null || props.idInscripcion === -1)
            return;

        let productosOfrecidos = [];
        let productosDemandados = [];
        let rubros = [];

        if (esFiltrar) {
            // Construcción original de los arrays
            badgesOferta.forEach(e => productosOfrecidos.push(e.label));
            badgesDemanda.forEach(e => productosDemandados.push(e.label));

            productosOfrecidos.push(...(badgesOferta.length ? badgesOferta.map(e => e.value) : ['']));
            productosDemandados.push(...(badgesDemanda.length ? badgesDemanda.map(e => e.value) : ['']));
            rubros.push(...(badgesRubro.length ? badgesRubro.map(e => e.value) : [-1]));

            // Guardar filtros nuevos
            setFiltros({
                productosOfrecidos,
                productosDemandados,
                rubros
            });

        } else {
            // Recuperar filtros anteriores
            productosOfrecidos = filtros.productosOfrecidos;
            productosDemandados = filtros.productosDemandados;
            rubros = filtros.rubros;
        }

        const params = {
            inscripcionId: props.idInscripcion,
            productosDemandados,
            productosOfrecidos,
            rubros,
            unionLaboral: -1,
            page: esPaginacion ? pagActual - 1 : 0,
            nombre: esFiltrar ? "" : props.search
        };

        getElements(params, 'empresa/empresasQuePodrianInteresarteDeUnEvento', 'POST');
    }

    /*function filtrarNombre() {
        const filtro = document.getElementById("buscarText").value;
        if (filtro.localeCompare("") !== 0) {
            let elemPagina = [];
            var contPaginas = 0;
            var contElem = 0;
            var elemActFaltan = true;
            setElementos([])
            elementosTotal.map(function (elem) {
                if (elem.nombre.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
                    .includes(filtro.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ""))) {
                    elemPagina.push(elem);
                    contElem++;
                    if ((contElem) % Math.floor(cantidadElementos) === 0) {
                        var objeto = elemPagina;
                        setElementos(elementos => [...elementos, objeto])
                        if (elemActFaltan) {
                            //setPaginaActual(objeto);
                            elemActFaltan = false;
                        }
                        elemPagina = [];
                        contPaginas++;
                    }
                }
            });
            if (elemPagina.length !== 0) {
                var objeto = elemPagina;
                setElementos(elementos => [...elementos, objeto])
                if (elemActFaltan) {
                    //setPaginaActual(objeto);
                    elemActFaltan = false;
                }
                contPaginas++;
            }
            if (elemActFaltan) {
                //setPaginaActual([]);
            }
            if (contPaginas === 0)
                contPaginas++;
            setCantPaginas(contPaginas);
        }
        else
            quitarFiltro()
    }
    
    function quitarFiltro() {
        setElementos(elementosCopia);
        //setCantPaginas(cantPaginasCopia);
        setPrimeraCarga(true);
    }*/

    function agregarModificado(idElem, idInscripcion) {
        if (idInscripcion !== undefined)
            setIdsElemModif(idsElemModif => [...idsElemModif, { idEmpresa: idElem, idInscripcion: idInscripcion }]);
        else
            setIdsElemModif(idsElemModif => [...idsElemModif, idElem]);
    }

    useEffect(() => {
        if (primeraCarga && elementos.length !== 0) {
            setPrimeraCarga(false);
            //cambiarPagina(1);
            //document.getElementById('loader').classList.add("ocultarLoader");
            //document.getElementById('colLoader1').classList.add("ocultarLoader");
            //document.getElementById('colLoader2').classList.add("ocultarLoader");
        }
        //setPaginaActual(1);
    }, [elementos])

    /* function cambiarPagina(numPagina) {
         elementos.map(function (elem, i) {
             if (i === numPagina - 1) {
                 setPaginaActual(elem);
             }
         });
     }*/

    function seleccionarEvento(evento) {
        localStorage.setItem(process.env.REACT_APP_ID_EVENTO, evento.id);
        setHoraEntrada(evento.horaInicio);
        setHoraSalida(evento.horaFin);
        setPermitirElegirHorario(evento.permitirElegirHorario);
    }

    function reunirse(idEmpresa) {
        const params = {
            params: {
                idInscripcion: props.idInscripcion,
                idEmpresa: idEmpresa
            }
        }
        axios
            .post(process.env.REACT_APP_URL + 'inscripcion/agregarEmpresaInteres', null, params)
            .then((res) => {
                agregarModificado(idEmpresa, props.idInscripcion);
                toastSuccess("Solicitud Enviada");
            })
            .catch(function (error) {
                toastError(handleError(error))
            })

    }

    function elementoModificado(idElem, idInscripcion) {
        var ret = false
        idsElemModif.map(function (id) {
            if (idInscripcion !== undefined) {
                if (id.idEmpresa.localeCompare(idElem) === 0 && id.idInscripcion.localeCompare(idInscripcion) === 0) {
                    ret = true;
                }
            }
            else {
                if (id.localeCompare(idElem) === 0) {
                    ret = true;
                }
            }
        });
        return ret;
    }

    function inscribirse(evento) {
        if (inscribiendo !== null)
            return;
        var url = 'inscripcion/crearInscripcionSinHorario';

        var params = {
            horaInicio: evento.horaInicio,
            horaFin: evento.horaFin,
            empresaInscripta: {
                id: localStorage.getItem(process.env.REACT_APP_ID_EMPRESA)
            },
            evento: {
                id: evento.id
            }
        }
        setInscribiendo(evento.id);
        axios
            .post(process.env.REACT_APP_URL + url, params)
            .then((res) => {
                //if(!props.esModificar)
                agregarModificado(evento.id);
                toastSuccess("Inscripción realizada")

                //document.getElementById("btnClose").click();
            })
            .catch(function (error) {

                if (error.response.data === "Error al inscribirse, comuníquese al número: 11-5754-6680")
                    toastErrorUniqueInfinite(handleError(error))
                else
                    toastError(handleError(error))
            })
            .finally(() => setInscribiendo(null));
    }

    function eliminarEvento(id) {
        const params = {
            params: {
                id: id
            }
        }
        axios
            .delete(process.env.REACT_APP_URL + 'evento', params)
            .then((res) => {
                //agregarModificado(idEmpresa, props.idInscripcion);
                toastSuccess("Evento eliminado");
            })
            .catch(function (error) {
                toastError(handleError(error))
            })
    }

    return (
        <>

            <div className='container-fluid bg-white rounded-4 textoTablas tabla position-relative mx-0 mx-sm-auto ' id='tabla' >
                <div className='row encabezadosTablas py-3 px-sm-3 px-0 bordeTablas align-items-center ocultarMobile'>
                    {props.seccionId === 2 ?
                        <>
                            <div className='col text-center '>
                                <div className='mostrarNombreEmpresaMobile d-none'>Empresa</div>
                                <div className='ocultarNombreEmpresaMobile'>Nombre de la empresa</div>

                            </div>
                            <div className='col text-center'>
                                Rubros
                            </div>
                            <div className='col text-center'>
                            </div>
                        </>
                        :
                        <>
                            <div className='col'>
                                <div className='mostrarNombreMobile d-none'>Evento</div>
                                <div className='ocultarNombreMobile'>Nombre del evento</div>
                            </div>
                            <div className='col text-center'>
                                Fecha
                            </div>
                            <div className='col text-center'>
                                Horarios
                            </div>
                            <div className={'text-center col-sm-2' + (props.esAdmin ? "" : " w-fit-content")}>
                                {props.esAdmin ?
                                    <></>
                                    :
                                    <div className='textInscribirse'>Inscribirse</div>}
                            </div>
                        </>
                    }

                </div>
                {mostrarLoader ?
                    <LoaderTabla />
                    :
                    <div className='alturaScrollTabla  scrollArea px-3 px-sm-0 '>
                        {elementos.length !== 0 ?

                            elementos.map(function (elem, i) {
                                return (
                                    <div id={'idElem' + i} className='row py-3 px-0 px-sm-3 bordeTablas align-items-center mx-0 marginTabla itemsTabla' >
                                        {props.seccionId === 1 ?
                                            <>
                                                <div className='col-sm col-12 mb-3 mb-sm-0 nombreEventoMobile'>
                                                    {elem.nombre}
                                                </div>
                                                <div className='col text-center '>
                                                    {elem.fecha}
                                                </div>
                                                <div className='col text-center'>
                                                    {elem.horaInicio + " / " + elem.horaFin}
                                                </div>
                                                <div className={'text-end col-sm-2 col centrarMobile' + (props.esAdmin ? "" : " w-fit-content")}>
                                                    {props.esAdmin ?
                                                        <>
                                                            <img className='cursor-pointer' src={logoEditar} alt="" />
                                                            <img className='ms-3 cursor-pointer' src={logoEliminar} alt="" onClick={() => eliminarEvento(elem.id)} />
                                                        </>
                                                        :
                                                        <>
                                                            {elementoModificado(elem.id) ? (
                                                                <button class="btn text-white bold-botones btnDisabled btn-cuadrado textInscribirse" type="submit" data-bs-toggle="modal"
                                                                    data-bs-target="#staticBackdrop">Inscripto</button>
                                                            ) : elem.tieneCupo === false ? (
                                                                <button class="btn text-white bold-botones btnDisabled btn-cuadrado textInscribirse" type="submit">Sin Cupo</button>
                                                            ) :
                                                                <>
                                                                    {elem.permiteReuniones ?
                                                                        <button class="btn colorPrincipal text-white bold-botones btn-cuadrado" type="submit" data-bs-toggle="modal"
                                                                            data-bs-target="#staticBackdrop" onClick={() => seleccionarEvento(elem)}>Inscribirse</button>
                                                                        :
                                                                        <button class="btn colorPrincipal text-white bold-botones btn-cuadrado" type="submit"
                                                                            disabled={inscribiendo === elem.id} onClick={() => inscribirse(elem)}>Inscribirse</button>
                                                                    }
                                                                </>
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            </>
                                            :
                                            <>
                                                <div className='text-center col-sm-4 col-12 mb-3 mb-sm-0 nombreEventoMobile'>
                                                    {elem.nombre}
                                                </div>
                                                <div className='col-6 col-sm-4 text-center col-rubro ocultarMobile multiline-ellipsis'>
                                                    {elem.rubros.length !== 0 ?

                                                        elem.rubros.map(function (rubro, i) {
                                                            return (
                                                                i == 0 ?
                                                                    rubro
                                                                    :
                                                                    " / " + rubro
                                                            )
                                                        })
                                                        :
                                                        <></>
                                                    }
                                                </div>

                                                {/*
                                <div className='col text-end ps-0'>
                                    <button class="btn btn-outline-primary bold-botones btn-cuadrado" data-bs-toggle="modal" 
                                    data-bs-target="#modalPerfil" onClick={()=>setPerfil(elem)}>Ver Perfil</button>                     
                                </div>
                                <div className='col  text-start pe-0'>
                                    {elementoModificado(elem.id, props.idInscripcion)?
                                        <button class="btn text-white bold-botones btnDisabled btn-cuadrado w-btn-reunirse" type="submit" 
                                        >Enviada</button>   
                                    :
                                        <button class="btn colorPrincipal text-white bold-botones btn-cuadrado"  type="submit" 
                                        onClick={()=>reunirse(elem.id)}>Reunirse</button>  
                                    }                     
                                </div>
                               */}
                                                <div className='col text-center px-0'>
                                                    <button class="btn btn-outline-primary bold-botones btn-cuadrado btn-verperfil-empresas " data-bs-toggle="modal"
                                                        data-bs-target="#modalPerfil" onClick={() => setPerfil(elem)}>Ver Perfil</button>
                                                    {elementoModificado(elem.id, props.idInscripcion) ?
                                                        <button class="btn text-white bold-botones ms-4 btnDisabled btn-cuadrado btn-reunirse " type="submit"
                                                        >Enviada</button>
                                                        :
                                                        <button class="btn colorPrincipal text-white ms-4 bold-botones btn-cuadrado btn-reunirse" type="submit"
                                                            onClick={() => reunirse(elem.id)}>Reunirse</button>
                                                    }
                                                </div>

                                            </>
                                        }
                                    </div>


                                )
                            })
                            :
                            <>
                                {props.seccionId === 1 ?
                                    <p className='text-center mt-4'>No se encontraron eventos</p>
                                    :
                                    <p className='text-center mt-4'>No se encontraron empresas</p>
                                }
                            </>
                        }
                    </div>
                }
                <Paginacion cantPaginas={cantPaginas} pagActual={pagActual} setPagActual={setPagActual} />
            </div>
            <ModalPerfil perfil={perfil} isEditar={false} reunirse={reunirse} elementoModificado={elementoModificado}
                idInscripcion={props.idInscripcion} />
            {props.seccionId === 1 ?
                <Modal agregarModificado={agregarModificado} esModificar={false} horaInicioEvento={horaEntrada} horaFinEvento={horaSalida}
                    permitirElegirHorario={permitirElegirHorario} />
                :
                <>
                </>
            }
            {props.seccionId === 2 && <Filtros seleccionarEmpresas={seleccionarEmpresas} />}
        </>
    );
}


export default Tabla;